<template>
  <div ref="handles" class="pf-annotation--resizer" @mousedown="updatePlot($event)">
    <div
      v-if="!dragging"
      class="pf-annotation--resizer_handle left x"
      ref="leftHandle"
      @mousedown="resizing($event, 'leftHandle')"
    >
      <div class="pf-annotation--resizer_inner"></div>
    </div>
    <div
      v-if="!dragging"
      class="pf-annotation--resizer_handle right x"
      ref="rightHandle"
      @mousedown="resizing($event, 'rightHandle')"
    >
      <div class="pf-annotation--resizer_inner"></div>
    </div>
    <div class="pf-annotation--resizer_handle move">
      <mds-icon name="move" />
    </div>
  </div>
</template>

<script>
  import repoMixin from '../../mixins/interactions/reposition';

  export default {
    name: 'PfHandler',
    mixins: [repoMixin],
    props: {
      bandX: {
        type: Array,
      },
      configuration: {
        type: Boolean,
        default: true,
      },
      scaleTypeX: {
        type: String,
      },
      scaleTypeY: {
        type: String,
      },
      domainX: {
        type: Array,
        required: true,
      },
      domainY: {
        type: Array,
        required: true,
      },
      paddingInner: {
        type: Number,
        default: 0.1,
      },
      rangeX: {
        type: Array,
        required: true,
      },
      rangeY: {
        type: Array,
        required: true,
      },
      transpose: {
        type: Boolean,
        default: false,
      },
      x: {
        type: Number,
        required: true,
      },
      y: {
        type: Number,
        required: true,
      },
      width: {
        type: Number,
        default: 150,
      },
      yAxisWidth: {
        type: Number,
        default: 86,
      },
    },
    data() {
      return {
        dragging: false,
        resizeEl: '',
        size: 24,
      };
    },
    watch: {
      transpose(val) {
        this.transposeScale = val;
      },
    },
    methods: {
      updatePlot(e) {
        this.configProp = 'plot';
        this.repositioning(e);
      },
      resizing(e, ref) {
        this.resizeEl = ref;
        this.trap(e);

        document.addEventListener('mousemove', this.updateSize);
        document.addEventListener('mouseup', this.endListeners);
      },
      updateSize(e) {
        if (this.resizeEl === 'leftHandle') {
          this.$emit('pfresize', {
            left: e.movementX,
            width: -e.movementX,
          });
        } else {
          this.$emit('pfresize', {
            left: 0,
            width: e.movementX,
          });
        }
      },
      endListeners() {
        document.removeEventListener('mousemove', this.updateSize);
        document.removeEventListener('mouseup', this.endListeners);
      },
    },
    mounted() {
      this.configProp = 'plot';
      this.handler = true;
      this.transposeScale = this.transpose;
    },
  };
</script>

<style lang="scss">
  @import '@mds/constants';

  .pf-annotation--resizer {
    position: absolute;
    height: 100%;
    left: 0;
    top: 0;
    width: 100%;
    min-width: 60px;
    cursor: move;

    .pf-annotation--selected & {
      border: 3px solid $mds-interactive-color-primary-default;
    }

    &_handle {
      align-items: center;
      display: flex;
      justify-content: center;
      pointer-events: auto;
      position: absolute;

      &.x {
        cursor: ew-resize;
        height: 10px;
        top: 0;
        width: 10px;
      }

      &.left {
        left: -5px;
      }

      &.right {
        right: -5px;
      }

      &.move {
        height: 24px;
        width: 24px;
        background: white;
        border-radius: 50%;
        bottom: -30px;
        right: 0;
        border: 1px solid rgba($mds-interactive-color-primary-default, 0.5);
        opacity: 0;

        &:hover {
          background: $mds-interactive-color-primary-default;
        }

        .pf-annotation--selected & {
          opacity: 1;
        }

        .move-icon svg {
          height: 16px;
          position: absolute;
          transform: rotate(calc(var(--rotation) * -1));
          width: 16px;
          top: 3px;
          left: 3px;
        }
      }
    }

    &_inner {
      background: white;
      border: 2px solid $mds-interactive-color-primary-default;

      // border-radius: 2px;
      opacity: 0;
      position: absolute;
      transition: opacity 0.2s;

      .x & {
        height: 10px;
        max-height: 40px;
        min-height: 10px;
        width: 10px;
      }

      .pf-annotation--selected & {
        opacity: 1;
      }
    }
  }
</style>

<style module lang="scss">
  // MDS overrides only
  @import '@mds/constants';
  @import '@mds/typography';

  :global(.pf-annotation--resizer_handle) {
    .mds-icon {
      stroke: transparent;
    }
  }
</style>
